import i18next from 'i18next'

/**
 * Takes already formatted monetary value as input, e.g. "1.045,44 €", "$112,412.34" or even
 * "1.123,34 RSD" and removes all numbers, spaces and delimiters, leaving just the currency symbol.
 *
 * There is no native Web API solution to map the ISO 4217 currency code("EUR" or "USD") to its
 * respective symbol("€", "$" or "RSD") without this kind of transformation. Until backend provides us with
 * the symbol in all tariff and cost responses, this workaround must be applied.
 */
export const currencyCodeToSymbol = (currencyCode: string, language?: string): string | undefined => {
  const parts = new Intl.NumberFormat(language ?? i18next.language, { style: 'currency', currency: currencyCode }).formatToParts(0)
  const currencyPart = parts.find(part => part.type === 'currency')

  return currencyPart?.value
}
